@if (paymentDetail && paymentCustomerReference) {
    <div class="row mb-4">
        <app-details-header>
            <span class="my-3"><strong>Customer reference</strong></span>
        </app-details-header>
        @for (item of paymentCustomerReference; let itemIndex = $index; track itemIndex) {
            @if (item.show) {
                <app-details-field class="col-12 col-md-4" [label]="item.label ?? ''" [value]="item.value" />
            }
        }
        @for (field of dynamicFields; let fieldIndex = $index; track fieldIndex) {
            <app-details-field class="col-12 col-md-4" [label]="field.label ?? ''" [value]="field.value" />
        }
        @if (files.length) {
            <app-files-container [filesPath]="files" [title]="fileName" />
        }
    </div>
}
